<div class="container">
  <div class="container-title">PAX</div>
  <div class="container-content">
    <div class="container-paragraph" style="color: red;">
      중요! 팍스 토큰은 클레이튼 네트워크의 Nectar로 스왑될 예정입니다. <br />
      팍스 브릿지를 사용해서 KPAX로 스왑 후 Nectar로 스왑할 수 있습니다.
    </div>
    <div class="container-paragraph">
      PAX is a token used in the CxNxD ecosystem and is used to use the utility provided by CxNxD.
    </div>
  </div>
</div>

<style>
  .container-content {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    align-items: center;
  }

  .container-paragraph {
    width: 55%;
    margin-bottom: 30px;
  }

  @media screen and (max-width: 768px) {
    .container-paragraph {
      align-items: center;
      width: 100%;
    }
  }
</style>
